import DynIcon from './DynIcon';
import React from 'react';
import { translate } from 'react-i18next';

class FacilitiesIcons extends React.Component {
   constructor(props) {
      super(props);
   }

   render() {

      const { facilities } = this.props;
      const lang = localStorage.getItem('i18nextLng');
      const descriptionKey = lang ? 'description_' + lang : 'description_en';

      return (
         <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
            {
               facilities.map(service =>
                  <span key={service.code} style={{marginRight: '10px'}} title={service[descriptionKey]}>
                     <DynIcon key={service.code} icon={service.group} style={{ color: '#878787', width: '16px' }} />
                  </span>
               )
            }
         </div>
      )
   }
}

FacilitiesIcons.defaultProps = {
   facilities: []
}

export default translate('translations')(FacilitiesIcons);


// WEBPACK FOOTER //
// ./src/components/Utils/FacilitiesIcons.js